//=require ../../../global/js/base/1_functions.js
//=require ../../../global/js/base/2_ResizeSensor.js
//=require ../../../global/js/base/3_toastr.js

//=require ../../../admin/js/ajaxForm/ajaxForm.js

$(document).find(".submit-btn").on("click", function (e) {
    e.preventDefault();
    $(this).closest("form").submit();
});

$(document).on('click', '.smooth-scroll', function (e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
    }, 1500);
});

function iframeListener(event) {
    if (event.data.message === 'pickerResult') {
        // Zpracovani event.data.point, pripadne event.data.phone
        //  console.log(event.data);
        chooseOption($(document).find('.cs-post-choose'), event.data.point);
    }
}
window.addEventListener('message', iframeListener);


// Delivery and payments methods
$(document).on('click', '.option', function () {
    if ($(this).hasClass('active')) {
        return;
    }

    if($(this).hasClass('packeta-choose')){
        let country = $(this).data('country');
        Packeta.Widget.pick(PACKETA_API_KEY, showSelectedPickupPoint, {
            country: country
        });
        return;
    }
    chooseOption($(this));
});

$(document).on('click', '.cs-post-choose', function() {
    $(this).closest('.content').find('.cs-post-map').show();
});

// Delivery and payments methods
$(document).on('click', '.change-packeta', function () {
    let country = $(this).closest('.option').data('country');
    Packeta.Widget.pick(PACKETA_API_KEY, showSelectedPickupPoint, {
        country: country
    });
});

function chooseOption(element, info = null){

    let content = element.closest('.content');
    content.find('.option.active').removeClass('active');
    element.addClass('active');

    let input = content.find('input.result');
    //input.val($(this).data('value'));

    let formData = {};
    formData.value = element.data('value');
    if(info){
        formData.info = info;
    }

    $.nette.ajax({
        url: input.data("href"),
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        },
        success: function (payload) {

        },
        error: function (err) {

        }
    });
}

function showSelectedPickupPoint(point) {
    let info = $(document).find('.packeta-info');
    let changeHref = $(document).find('.change-packeta');

    if (point) {
        chooseOption($(document).find('.packeta-choose'), {id: point.id, name: point.name});
    } else {
        info.text('nevybrána');
        changeHref.text('vybrat');
    }
    changeHref.show();
}

$(document).on('click', '#submit-order-virtual-btn', function () {
    $(document).find('#submit-order-btn').click();
});
$(document).on('click', '#submit-registration-virtual-btn', function (e1) {
    $(document).find('#submit-registration-btn').click();
});

$(document).on("submit", ".registration-form", function (e1) {
    e1.preventDefault();

    let butt = $(document).find("#submit-registration-virtual-btn");
    if (butt.hasClass('disabled')) {
        return;
    }

    butt.addClass("disabled");
    butt.find(".fa-spinner").show();
    let form = $(this);

    let formData = new FormData(this);
    let formUrl = form.attr("action");

    function auth(formUrl, formData)
    {
        $.nette.ajax({
            url: formUrl,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
            off: {
                snippets: true
            },
            success: function (payload) {

                console.log(payload);

                if (payload.error) {
                    toastr.warning(payload.error);
                }
                butt.find(".fa-spinner").hide();
                butt.removeClass('disabled');
            },
            error: function (err) {
                console.log('chyba');
                console.log(err);
                butt.find(".fa-spinner").hide();
                butt.removeClass('disabled');
            }
        });

    }

    if (ENABLE_RECAPTCHA) {
        grecaptcha.ready(function () {
            grecaptcha.execute(RECAPTCHA_PUBLIC_KEY, {action: 'login'}).then(function (token) {

                formData.append('token', token);
                formData.append('action', 'login');

                auth(formUrl, formData);

            });
        });
    } else {
        auth(formUrl, formData);
    }
});

$(document).on('keyup', '.search-input', function () {
    if($(this).val().length == 0) {
        $(".search-result-container").addClass("d-none");
    } else {
        $(".loading").removeClass("d-none");
        $(".search-result-container").removeClass("d-none");
    }
});

$(document).on('click', '.close-search-result', function (e) {
    e.preventDefault();
    $(".search-result-container").addClass("d-none");
});

$(document).on('click', '#showMoreButton', function (e) {
    e.preventDefault();
    $(this).closest("form").submit();
});

$(document).on('click', '.searchhead', function () {
    let closeIcon = $(this).find('.close-icon');
    if(closeIcon.is(':visible')){
        closeIcon.hide();
        $(this).find('.search-icon').show();
        $(document).find('.search-container').hide();
    }else{
        closeIcon.show();
        $(this).find('.search-icon').hide();
        $(document).find('.search-container').show();
    }
});
$(document).on('click', '.carthead', function () {
    window.location = $(this).find(".cart").attr('href');
});


$(document).on('mousedown', '.mask', function (e) {
    if(e.target.getAttribute("class") == "mask") {
        $(this).addClass("d-none");
    }
});

$(document).on('click', '.signIn-close', function (e) {
    e.preventDefault();
    $(".mask").addClass("d-none");
});

$(document).on('click', '.signIn-button', function (e) {
    e.preventDefault();
    $(".mask").removeClass("d-none");
});

$(document).on('click', '.cancel-filter-virtual', function (){
    $(document).find('#cancel-filter button').click();
});

$(document).on('click', '.clickable-product', function (){
    location.href = $(this).find('a.img').attr('href');
});

$(document).on('click', '.show-other-categories', function (){
    $(this).hide();
    $(document).find('.hidden-category').css('display', 'flex');
});

$(document).on('click', '.freetransport', function (e) {
    e.preventDefault();
    let href = $(this).data('href');
    if(href){
        window.location.href = href;
    }
});

$(document).ready(function (){
    $(document).on('click', '.other-payment-show', function (){
        $(this).hide();
        $(document).find('.hidable').show();
    });

    $(document).on('click', '.other-payment-hide', function (){
        $(this).hide();
        $(document).find('.other-payment-show').show();
        $(document).find('.hidable').hide();
    });

    $(document).on('click', '#show-filters', function (){
        $(document).find('#filters-panel').show();
    });
    $(document).on('click', '#show-filters', function (){
        var panel = $(document).find('#filters-panel');
        var header = $(panel).find(".head");

        header.css("position", "absolute"); // Dočasná změna pozice na absolute
        panel.css({ left: "-100%", display: "block" })
             .animate({ left: "0" }, 500, function() {
                 header.css("position", "fixed").css("top", "71px"); // Po dokončení změna na fixed
             });
    });
    $(document).on('click', '.hide-filters', function (){
        var panel = $(document).find('#filters-panel');
        var header = $(panel).find(".head");
        header.css("position", "absolute").css("top", "0");
        panel.animate({ left: "-100%" }, 500, function() {
            panel.css("display", "none"); // Vrácení pozice
        });

    });
});

document.addEventListener("DOMContentLoaded", function() {
    // Pokud Lightbox2 detekuje prvky automaticky
    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true
    });
});